
import { mapGetters, mapActions } from "vuex";
import useMetaIcons from "~/mixins/useMetaIcons";
import useGtm from "~/mixins/useGtm";

export default {
  components: {
    SystemPopup: () => import("~/components/popups/SystemPopup"),
    AppFooter: () => import("~/components/common/AppFooter"),
    HeaderCheckout: () => import("@/components/common/HeaderCheckout.vue"),
    // SideMenu: () => import("~/components/common/SideMenu.vue"),
  },
  mixins: [useMetaIcons, useGtm],
  head() {
    return {
      script: [this.stripeScript],
    };
  },
  computed: {
    ...mapGetters({
      stripeIntegration: "general/stripeIntegration",
    }),
    stripeScript() {
      return this.stripeIntegration
        ? { src: "https://js.stripe.com/v3/", async: true }
        : {};
    },
  },
  methods: {
    ...mapActions({
      setCheckoutCartInfo: "cart/setCheckoutCartInfo",
    }),
  },
  beforeDestroy() {
    this.setCheckoutCartInfo(null);
  },
};
